import { useState } from "react";
import AnnouncementModal from "../AnnouncementModal";

const MessageContent = ({
  messageTitle,
  messageImage,
  messageDetails,
  messageType,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="tw-bg-white tw-rounded-xl tw-p-5 tw-relative tw-overflow-auto tw-max-h-[300px]">
      <div className="tw-flex tw-justify-between tw-items-start tw-mb-3">
        <h2
          title={messageTitle}
          className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
        >
          {messageTitle}
        </h2>
        <span className="tw-rounded-full tw-text-white tw-bg-primary tw-text-[12px] tw-px-3 tw-py-1">
          {messageType ?? ""} Message
        </span>
      </div>

      <div className="tw-flex tw-gap-4 tw-flex-col md:tw-flex-row">
        <div className="tw-flex-1 tw-text-gray-700 tw-leading-relaxed">
          <p>{messageDetails}</p>
        </div>

        {messageImage && (
          <div
            className="tw-w-full md:tw-w-1/4 tw-rounded-lg tw-overflow-hidden tw-cursor-pointer tw-shadow-sm tw-border tw-border-gray-200"
            onClick={() => setIsOpen(true)}
          >
            <img
              src={messageImage}
              alt="message"
              className="tw-w-full tw-h-full tw-object-cover"
            />
          </div>
        )}
      </div>

      {messageImage && (
        <AnnouncementModal
          isOpen={isOpen}
          onClose={setIsOpen}
          imageSrc={messageImage}
        />
      )}
    </div>
  );
};

export default MessageContent;
